// extracted by mini-css-extract-plugin
export default {"main":"FooterAuth_main__u3vGn","footerLogo":"FooterAuth_footerLogo__x2KXc","cp":"FooterAuth_cp__zie6t","content":"FooterAuth_content__fLADe"};